import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import AdoptionsMiddleware from './../modules/adoption/middleware'
import Dialog from 'react-modal'
import ModalSendBooks from './../components/Modal/ModalSendBooks'

const mapStateToProps = ({ adoption, auth }) => ({
  isOpenBooksModal: adoption.isModalOpen,
  adoptionsSend: adoption.adoptionsSend.items,
  role: auth.userRole.role
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    toggleModal: () => AdoptionsMiddleware.modalAdoptionsToggleView(),
    fetchAdoptions: params => AdoptionsMiddleware.fetchAdoptions(),
    postAdoptionSend: params => AdoptionsMiddleware.postAdoptionSend(),
    postAdoptionApprove: params => AdoptionsMiddleware.postAdoptionApprove()
  }, dispatch)
}

class ModalSendBooksContainer extends Component {
  UNSAFE_componentWillMount () { // eslint-disable-line
    if (!this.props.isOpenBooksModal) { this.props.toggleModal() }
  }
  handleSend = () => {
    if (this.props.role === 'fractal_operator') {
      this.props.postAdoptionApprove()
    } else {
      this.props.postAdoptionSend()
    }
    this.closeModal()
  }
  handleCloseModal = () => {
    this.closeModal()
  }
  closeModal = () => {
    const { history, toggleModal, fetchAdoptions } = this.props
    fetchAdoptions()
    toggleModal()
    history.push('/adoption')
  }
  render () {
    return (
      <Dialog
        isOpen={this.props.isOpenBooksModal}
        contentLabel='Modal'
        onRequestClose={this.handleCloseModal}
        className='dialog dialog--modal'
      >
        <ModalSendBooks
          handleCloseModal={this.handleCloseModal}
          list={this.props.adoptionsSend}
          handleSend={this.handleSend}
        />
      </Dialog>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalSendBooksContainer))



// WEBPACK FOOTER //
// ./src/containers/ModalSendBooksContainer.js